












































import {
  Component,
  Vue,
  Prop,
  Emit,
} from 'vue-property-decorator';

@Component
export default class NotifyPromotionDialog extends Vue {
  @Prop({ type: Boolean, required: true }) open: boolean|undefined;

  get dialog() {
    return this.open;
  }

  set dialog(value) {
    this.close();
  }

  @Emit('close-dialog')
  // eslint-disable-next-line class-methods-use-this
  close() {
    return false;
  }

  // eslint-disable-next-line class-methods-use-this
  async mounted() {
    const video: any = document.getElementById('promo-video');
    console.log('video', video);
    if (video) {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        await playPromise;
      }
    }
    document.addEventListener('click', () => {
      // any click will force my video to unmute
      video.muted = false;
    });
  }
}
